
import extend from '@/utils/vuex-extend';
import { dialog } from '@/vuex-extend';
import { getSupplierDetail } from '@/api/pcm/supplier';
import { wait } from '@/utils/wait';

export default extend(dialog, {
    namespaced: true,
    state: {
		id: 0,
        detail: {}
    },
    actions: {
        async afterOpenDialog({ dispatch, commit, state }, payload) {
            const { id } = state;
            await wait(dispatch, 'pcm.supplier.detail', async function() {
                const response = await getSupplierDetail(id);
                commit('save', {
                    detail: response.data
                })
            })
        }
    }
})



// WEBPACK FOOTER //
// ./src/store/modules/pcm/supplier/detail.js